export default __webpack_public_path__ + "7f14f83304aac76e402441b72c85c605.woff";